import {useState,useEffect,useRef}from 'react'
import { Modal,App,Form,Input,} from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useYhUpdateSaveMutation,useYhUpdateQuery} from '../../store/BnsKeJiApi';
import MyEditor from '../../cpn/MyEditor';
import UploadOne from '../../cpn/UploadOne';
function ClientEdit(props) {
    const {message} = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        setOpen(false);
    };
    const [info,setInfo] = useState({
        'yh_id': props.yh_id,
        'yh_xm_id': props.bxm_id,
        'yh_xm_name': props.bxm_name,
        'yh_name': '',
        'yh_content': '',
        'yh_uid': props.eu_id,
        'yh_uname': props.eu_name,
        'yh_image': '',
    });
    const [defaultFileList, setDefaultFileList] = useState([]); 
    const {data,isSuccess} = useYhUpdateQuery({yh_id:props.yh_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    yh_content:data.Result.yh_content,
                    yh_name:data.Result.yh_name,
                    yh_image:[data.Result.yh_image],
                })
                setInfo(prevState=>({...prevState,         
                    yh_content:data.Result.yh_content,                         
                    yh_name:data.Result.yh_name,        
                    yh_image:data.Result.yh_image,
                }))
                
                // 将图片字符串转换为 UploadOne 组件需要的 defaultFileList 格式
                if(data.Result.yh_image && data.Result.yh_image.trim() !== '') {
                    const imageFiles = [{
                        uid: `existing-${data.Result.yh_image}`,
                        name: data.Result.yh_image,
                        status: 'done',
                        url: `/api/assets/images/application/${data.Result.yh_image}`,
                        thumbUrl: `/api/assets/images/application/${data.Result.yh_image}`,
                    }];
                    setDefaultFileList(imageFiles);
                } else {
                    setDefaultFileList([]);
                }
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useYhUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EditOutlined/> 修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改客户端'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit(info).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                     <Form.Item
                        name="yh_name"
                        label="客户端名称"
                        wrapperCol={{ span: 10 }}
                        rules={[{ required: true, message: '请输入客户端名称' }]}
                    >
                        <Input
                            onChange={(e) => { setInfo(prevState => ({ ...prevState, yh_name: e.target.value })) }}
                        />
                    </Form.Item>
                    <UploadOne 
                        fileStr={(fileStr) => { setInfo(prevState => ({ ...prevState, yh_image: fileStr })) }} 
                        label="客户端头像"
                        name="yh_image"
                        defaultFileList={defaultFileList}
                        maxCount={1}
                    />
                    <Form.Item
                        name="yh_content"
                        label="备注"
                        wrapperCol={{ span: 20 }}
                    >
                        <MyEditor
                            onChange={(e) => { setInfo(prevState => ({ ...prevState, yh_content: e})) }}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ClientEdit
